import { IsNotEmpty, IsString } from 'class-validator';

export class GetUnitTypesDto {
  @IsNotEmpty()
  @IsString()
  companyId: string;
}
